/* eslint-disable react-native/no-inline-styles */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import TodoProductItem from '@/screens/sales-activity/components/todo-list/on-going/product/TodoProductItem';
import { KeyboardAwareFlatList } from 'react-native-keyboard-aware-scroll-view';
import { productKeyExtractor } from './TodoVisibilityUpdate.utils';

const VisibilityResultProductList = ({
  products = [],
  filterProducts = (val) => val,
  detailData = {},
  detailTodo = {},
  handleProductUpdate = () => {},
  customerAddress = {},
  navigation = {},
  showProduct = false,
  accountGroupId = null,
  isValueSellOutOnly = false,
}) => {
  const listNode = useMemo(() => {
    const filtered = filterProducts(products);
    if (filtered.length === 0) {
      return (
        <View
          testID="todo-visibility-product-list-empty"
          style={styles.emptyWrapper}>
          <Image
            style={styles.emptyIcon}
            width={65}
            height={65}
            source={require('@assets/img/icons/no-product.svg')}
            svg
          />
          <SociollaText style={styles.emptyText}>
            No products found
          </SociollaText>
        </View>
      );
    }

    return (
      <KeyboardAwareFlatList
        testID="todo-visibility-product-list"
        style={{ flex: 1 }}
        data={filtered}
        windowSize={8}
        maxToRenderPerBatch={8}
        initialNumToRender={8}
        updateCellsBatchingPeriod={40}
        enableOnAndroid={true}
        extraScrollHeight={80}
        keyExtractor={productKeyExtractor}
        renderItem={({ item }) => (
          <TodoProductItem
            item={item}
            isDetail
            selectedProduct={products}
            activityId={detailData?._id}
            todoId={detailTodo?._id}
            onChange={(val) => handleProductUpdate(val, false)}
            customerAddress={customerAddress}
            taskIdStorage={detailTodo?._id || ''}
            isOtherProduct={false}
            navigation={navigation}
            showProduct={showProduct}
            accountGroupId={accountGroupId}
            isValueSellOutOnly={isValueSellOutOnly}
          />
        )}
      />
    );
  }, [
    products,
    filterProducts,
    detailData?._id,
    detailTodo?._id,
    handleProductUpdate,
    customerAddress,
    navigation,
    showProduct,
    accountGroupId,
    isValueSellOutOnly,
  ]);

  return listNode;
};

const styles = StyleSheet.create({
  emptyWrapper: {
    paddingTop: 60,
    paddingBottom: 30,
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyIcon: {
    width: 65,
    height: 65,
  },
  emptyText: {
    marginVertical: 10,
  },
});

VisibilityResultProductList.propTypes = {
  products: PropTypes.array,
  filterProducts: PropTypes.func,
  detailData: PropTypes.object,
  detailTodo: PropTypes.object,
  handleProductUpdate: PropTypes.func,
  customerAddress: PropTypes.object,
  navigation: PropTypes.object,
  showProduct: PropTypes.bool,
};

export default React.memo(VisibilityResultProductList);
